// extracted by mini-css-extract-plugin
export default {"titleHeader":"styles_titleHeader__FUS7F"};